// import React from 'react';
// import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import React, { useState, useContext, useee } from "react";
import Navbar from '../../Navbar';
// import Sidemenu from '../../Sidemenu';
import MainMenu from '../shared/menu/menu';
import { Account } from "../login/Account";
import { CustomerLandingPage } from "../customerLanding/customerLandingPage";
import { ChangePassword } from "../login/ChangePassword";
import { Home } from "../home/home";
import "./layout.scss"
// import FileUploadPage from '../FileUploadPage';
import styled from 'styled-components';

import { BrowserRouter as Router, redirect, Route, Switch, Routes } from "react-router-dom";
import { GenesisHome } from "../home/GenesisHome";
import { Dashboard_genesis } from "../dashboard/dashboard_genesis";
import { SequoiaHome } from "../home/SequoiaHome";
import { Dashboard_sequoia } from "../dashboard/dashboard_sequoia";
import MenuItemsUser from "../User/MenuItemsUser";
import Dashboard from "../dashboard/Dashboard"
import { Create_user } from "../home/Create_user";
import { Company_details } from "../home/Company_detail";

const Wrapper = styled.div`
    @media (min-width: 700px) {
        display: flex;
        top: 0px;
        position: relative;
       
        width: 100%;
        flex: auto;
        flex-direction: column;
    }
`;
const Main = styled.main`
    background-color: #fff;
    @media (min-width: 700px) {
        flex: 1;
        width: 100%;
        overflow: auto;
      
    }
`;

const Layout = ({ prop }) => {
    const [username, setUsername] = useState();
    const [authToken, setAuthToken] = useState();
    const [accessToken, setAccessToken] = useState(null);
    const [menuExpand, setMenuExpand] = useState();
    const [activeMenu, setActiveMenu] = useState('');
    const [selectedMenu, setSelectedMenu] = useState('');
    let selectMenu = () => {
        let m = sessionStorage.getItem('selectedMenu');
        setSelectedMenu(m);
        setActiveMenu(m);
    }
    let menuState = () => {
        let m = sessionStorage.getItem('menuState');
        setMenuExpand(m);
    }

    // useEffect(() => {
    // }, [selectedMenu]);

    return (
        <div id="MainPage" className={`App`}>
            <Account>
                <React.Fragment>
                    <Navbar />
                    <Wrapper className="main-content">
                        <MainMenu />
                        <Main>
                            {/* <Home/> */}
                            {/* <Route path="/home" element={<Home />} /> */}
                            <Routes >
                                {/* <Route path="/" exact element={<CustomerLandingPage />} /> */}
                                <Route path="/home" element={<Home />} />
                                <Route path="/dashboard" element={<CustomerLandingPage />} />
                                <Route path="/changepassword" element={<ChangePassword />} />
                                <Route path="/genesishome" element={<GenesisHome />} />
                                <Route path="/genesisdashboard" element={<Dashboard_genesis />} />
                                <Route path="/sequoiahome" element={<SequoiaHome />} />
                                <Route path="/dashboardsequoia" element={<Dashboard_sequoia />} />
                                <Route path="/createuser" element={<Create_user />} />
                                <Route path="/userdashboard" element={<Dashboard />} />
                                <Route path="/companydetails" element={<Company_details />} />
                            </Routes >
                        </Main>
                    </Wrapper>
                </React.Fragment>
            </Account>
        </div>
    );
};
export default Layout;